import Layout from "./table/Layout";
import React from "react";


type ListingProps = {
  isLoading: boolean;
  bannerRef: any;
}

const Listing = (props: ListingProps) => {
  const {isLoading, bannerRef} = props;
  return (
    <>
      <Layout isLoading={isLoading} bannerRef={bannerRef}/>
    </>
  );
};

export default React.memo(Listing);
